import Reader from "../io/Reader";
import { PlatformVideo } from "../../../types/video";

export default class ShapeArgs {
  /**
   * Decodes a ShapeArgs message from the specified reader.
   * @function decode
   * @memberof com.opensource.svga.ShapeEntity.ShapeArgs
   * @static
   * @param {$protobuf.Reader} reader Reader to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {com.opensource.svga.ShapeEntity.ShapeArgs} ShapeArgs
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  static decode(reader: Reader, length?: number): PlatformVideo.ShapePath {
    const { preflight } = reader;
    const end = reader.end(length);
    const hash = preflight.calculate(reader, end);

    if (preflight.has(hash)) {
      reader.pos = end;
      return preflight.get(hash);
    }

    const message = new ShapeArgs();
    let tag: number;

    while (reader.pos < end) {
      tag = reader.uint32();

      switch (tag >>> 3) {
        case 1: {
          message.d = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    preflight.set(hash, message);

    return preflight.get(hash);
  }

  /**
   * ShapeArgs d.
   * @member {string} d
   * @memberof com.opensource.svga.ShapeEntity.ShapeArgs
   * @instance
   */
  d: string = "";
}
